import BaseMap from 'components/BaseMap/BaseMap';
import { buildPinIcon } from 'features/Responder/features/ResponderMap/utils/pinIcon';
import PersonellLayer from 'features/Responder/features/Tours/features/TourMap/Components/PersonelLayer';
import { useUserLocation } from 'features/Responder/features/Tours/features/TourMap/hooks/useUserLocation';
import { useMemo } from 'react';
import { usePersonnel } from '../../../contexts/PersonnelContext';

const Map = () => {
  const { personnel } = usePersonnel();
  const { userPosition } = useUserLocation();

  const onlineIcon = useMemo(() => buildPinIcon('#27ae60'), []); // Green for clocked in
  const offlineIcon = useMemo(() => buildPinIcon('#7f8c8d'), []); // Gray for offline

  return (
    <BaseMap mapCenter={userPosition} zoom={3}>
      <PersonellLayer personnel={personnel} onlineIcon={onlineIcon} offlineIcon={offlineIcon} />
    </BaseMap>
  );
};

export default Map;
